import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import RecordWithdrawalRequestUsers from 'views/financial/withdrawalRequests/recordTableWithdrawalRequest'; // Importing a component for displaying withdrawal request users
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for recording withdrawal requests.
 * @extends JetView
 */
export default class recordWithdrawalRequestView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetching from configuration
                },
            ],
        };

        // Left panel configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme, // Applying the current theme
                    elements: [{ view: 'label', label: _('Historial') }], // Label for the toolbar
                },
                RecordWithdrawalRequestUsers, // Including the RecordWithdrawalRequestUsers component
                toolbar, // Adding the toolbar to the left panel
            ],
        };

        // Returning the main layout configuration
        return {
            height: screen.width < 500 ? 300 : 0, // Responsive height based on screen width
            type: 'wide', // Layout type
            cols: [left], // Columns configuration
        };
    }
}

// FILE DOCUMENTED
